import { SxProps, Theme } from '@mui/material';

const contentLayout: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  gap: 4
};

const verticalTabsContainer: SxProps<Theme> = {
  minWidth: '280px',
  maxWidth: '320px',
  flexShrink: 0
};

const contentContainer: SxProps<Theme> = {
  flex: 1,
  minWidth: 0
};

const emptyStateContainer: SxProps<Theme> = {
  py: 8,
  textAlign: 'center'
};

const divider: SxProps<Theme> = {
  my: 3
};

const contentDivider: SxProps<Theme> = {
  my: 5
};

export const administratorPageSx = {
  contentLayout,
  verticalTabsContainer,
  contentContainer,
  emptyStateContainer,
  divider,
  contentDivider
};
